import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37428dd8&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=37428dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37428dd8",
  null
  
)

export default component.exports